import React, { useState } from 'react';
import '../Css_files/Achievement.css';
import Image from './AppImage';
import Icon1 from './AppIcon';


const AchievementCard = ({ achievement, viewMode, onImageClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (viewMode === 'list') {
    return (
      <div 
        className="achievement-card list-view"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="card-content-list">
          <div className="card-image-container list-view">
            <Image
              src={achievement.image}
              alt={achievement.title}
              className={`card-image ${isHovered ? 'hovered' : ''}`}
            />
            <button
              onClick={() => onImageClick(achievement)}
              className="zoom-button"
            >
              <Icon1
                name="ZoomIn" 
                size={24} 
                className={`zoom-icon ${isHovered ? 'list-hovered' : ''}`}
              />
            </button>
          </div>
          
          <div className="card-content list-view">
            <div className="card-meta">
              <span className="category-badge list-view">
                {achievement.category}
              </span>
              <span className="card-date">{achievement.date}</span>
            </div>
            <h3 className="card-title">
              {achievement.title}
            </h3>
            <p className="card-description">
              {achievement.description}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="achievement-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-image-container grid-view">
        <Image
          src={achievement.image}
          alt={achievement.title}
          className={`card-image ${isHovered ? 'hovered' : ''}`}
        />
        
        {/* Overlay */}
        <div className={`image-overlay ${isHovered ? 'hovered' : ''}`}>
          <button
            onClick={() => onImageClick(achievement)}
            className="zoom-button"
          >
            <div className="zoom-icon-container">
              <Icon1 name="ZoomIn" size={20} className="zoom-icon" />
            </div>
          </button>
        </div>

        {/* Category Badge */}
        <div className="category-badge">
          <span>
            {achievement.category}
          </span>
        </div>
      </div>
      
      <div className="card-content">
        <div className="card-meta">
          <span className="card-date">{achievement.date}</span>
        </div>
        <h3 className="card-title">
          {achievement.title}
        </h3>
        <p className="card-description">
          {achievement.description}
        </p>
      </div>
    </div>
  );
};

export default AchievementCard;